module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2370974.b1488134.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2370974.pdf
// module id = 853
// module chunks = 0